module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d0c90aed47604658ef997be8e55f59c.png";